import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BreakpointsAsObject from './BreakpointsAsObject';
import ClientProvider from './client';
export default createDemo(import.meta.url, BreakpointsAsObject, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/usage/demos/breakpoints-as-object/BreakpointsAsObject.tsx",
    "fileName": "BreakpointsAsObject.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function BreakpointsAsObject() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          width: {\n            xs: 100, // theme.breakpoints.up('xs')\n            sm: 200, // theme.breakpoints.up('sm')\n            md: 300, // theme.breakpoints.up('md')\n            lg: 400, // theme.breakpoints.up('lg')\n            xl: 500, // theme.breakpoints.up('xl')\n          },\n        }}\n      >\n        This box has a responsive width.\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 21,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function BreakpointsAsObject() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box\n        sx={{\n          width: {\n            xs: 100, // theme.breakpoints.up('xs')\n            sm: 200, // theme.breakpoints.up('sm')\n            md: 300, // theme.breakpoints.up('md')\n            lg: 400, // theme.breakpoints.up('lg')\n            xl: 500, // theme.breakpoints.up('xl')\n          },\n        }}\n      >\n        This box has a responsive width.\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "            ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "100"
              ],
              ", ",
              [
                "span",
                "pl-c",
                "// theme.breakpoints.up('xs')"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "            sm: ",
              [
                "span",
                "pl-c1 di-num",
                "200"
              ],
              ", ",
              [
                "span",
                "pl-c",
                "// theme.breakpoints.up('sm')"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "            md: ",
              [
                "span",
                "pl-c1 di-num",
                "300"
              ],
              ", ",
              [
                "span",
                "pl-c",
                "// theme.breakpoints.up('md')"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "            lg: ",
              [
                "span",
                "pl-c1 di-num",
                "400"
              ],
              ", ",
              [
                "span",
                "pl-c",
                "// theme.breakpoints.up('lg')"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "            xl: ",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              ", ",
              [
                "span",
                "pl-c",
                "// theme.breakpoints.up('xl')"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            "          },"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            "        This box has a responsive width."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 21,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
